<template>
        <list
          :columns="columns"
          :modalCreate="modalCreate"
          :removeLink="removeLink"
          :cardLink="cardLink"
          :isUpdate="true"
          :isAdd="true"
          :itemLink="itemLink"
          :setLink="setLink"
          :fields="fields"
          :searchDisable="true"
          @change="change"
          @changeFunction="changeFunction"
          v-model="val"
        />
</template>
<script>
export default {
  name: "products",
props:{
  id: {
    default : null
  }
},
created() {
      this.itemLink =  `warehouse/options/${this.id}/serials`;
      this.setLink = `warehouse/options/${this.id}/serials`;
},
methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      val: [],
      modalCreate: "serial",
      fields: [
           {
              label: "Серийник",
              key: "barcode",
              type: "field",
              textType: "text", 
            },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_serial",
      itemLink: "warehouse/serials",
      setLink: "warehouse/serials",
      columns: [
        {
          key: "id",
          title: "ID",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "barcode",
          title: "Серийник",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
